import { RootState } from 'redux/schemas';

export const getDefaultColorPalette = (state: RootState) => Object.values(state.models.institutions[state.app.currentInstitutionId].orgColors.mainColors);

export const getHighlightColorPalette = (state: RootState) => Object.values(state.models.institutions[state.app.currentInstitutionId].orgColors.highlightColors);
